var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-field',{attrs:{"has-error":_vm.hasError,"error-label":_vm.errorLabel,"helper":_vm.helper,"label":_vm.label}},[_c('q-editor',{attrs:{"definitions":_vm.definitions,"toolbar":[
                ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
                ['token', 'hr', 'link', 'custom_btn'],
                ['print', 'fullscreen'],
                ['quote', 'unordered', 'ordered', 'outdent', 'indent'],
                [
                  {
                    label: _vm.$q.i18n.editor.align,
                    icon: _vm.$q.icon.editor.align,
                    fixedLabel: true,
                    list: 'only-icons',
                    options: ['left', 'center', 'right', 'justify']
                  },
                  {
                    label: _vm.$q.i18n.editor.align,
                    icon: _vm.$q.icon.editor.align,
                    fixedLabel: true,
                    options: ['left', 'center', 'right', 'justify']
                  }
                ],
                ['undo', 'redo'],
                [
                  {
                    label: 'Lending Point Variables',
                    icon: 'filter_1',
                    fixedLabel: true,
                    fixedIcon: true,
                    options: ['lendingPointName', 'lendingPointAddress', 'lendingPointEmail', 'lendingPointPhone', 'lendingPointCIF']
                  }
                ],
                [
                  {
                    label: 'Consumer Variables',
                    icon: 'filter_1',
                    fixedLabel: true,
                    fixedIcon: true,
                    options: ['consumerFirstName', 'consumerLastName', 'consumerEmail', 'consumerPrefix', 'consumerPhone', 'consumerDNI']
                  }
                ],
                [
                  {
                    label: 'Kit Variables',
                    icon: 'filter_1',
                    fixedLabel: true,
                    fixedIcon: true,
                    options: ['kitNumber', 'kitCodentify', 'kitCharger', 'kitHolder', 'kitColor', 'kitModel']
                  }
                ],
                [
                  {
                    label: 'Other Variables',
                    icon: 'filter_1',
                    fixedLabel: true,
                    fixedIcon: true,
                    options: ['startLendingAt', 'endLendingAt', 'owner', 'day', 'month', 'year']
                  }
                ]
              ]},on:{"input":_vm.onInput},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c7c5f8e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/form/VWyswyg.vue
// module id = zcqC
// module chunks = 44